import React, { FC, useState } from 'react'

import { WizzardPageBox } from '../style/UserWIzzardStyle'

import GenericInput from '../../../GenericComponents/GenericInput'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'

interface WizzardPage2Interface {
  setHipDimension: Function
  getHipDimension: number
}

const WizzardPage2: FC<WizzardPage2Interface> = ({ getHipDimension, setHipDimension }) => {
  return (
    <WizzardPageBox>
      <GenericInput
        onChange={(e: any) => setHipDimension(e.target.value)}
        tAlign={'center'}
        fSize={'2.5rem'}
        autoFocus
        placeholder={'Podaj wartość w cm'}
        className={'no-border color-white font-big-always dimension'}
        margin={'5% 0 0 0'}
        type="number"
        value={getHipDimension}
      />
      <GenericTextSpan margin={'8% 0 0 0'} fSize={'0.8rem'}>
        Te informacje widzisz TYLKO Ty i nikt nie ma do nich dostępu
      </GenericTextSpan>
    </WizzardPageBox>
  )
}

export default WizzardPage2
